import { render, staticRenderFns } from "./videoP.vue?vue&type=template&id=83cf760a&scoped=true&"
import script from "./videoP.vue?vue&type=script&lang=js&"
export * from "./videoP.vue?vue&type=script&lang=js&"
import style0 from "./videoP.vue?vue&type=style&index=0&id=83cf760a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83cf760a",
  null
  
)

export default component.exports